import { render, staticRenderFns } from "./TalentRecruitment.vue?vue&type=template&id=8bb7ed3c"
import script from "./TalentRecruitment.vue?vue&type=script&lang=js"
export * from "./TalentRecruitment.vue?vue&type=script&lang=js"
import style0 from "./TalentRecruitment.vue?vue&type=style&index=0&id=8bb7ed3c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports